import { z } from 'zod';
export const EMAIL_ALERT_CATEGORIES = ['monitoring', 'mail_certificates', 'backups', 'security'] as const;
const line = z.string().trim().max(254).refine(value => !/[\r\n\0]/.test(value), 'Use a single line');
export const notificationEmailConfigSchema = z.object({
  enabled: z.boolean(),
  host: z.string().trim().min(1).max(253).regex(/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)*[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/),
  port: z.number().int().min(1).max(65535),
  tlsMode: z.enum(['tls', 'starttls']),
  username: line,
  from: line.pipe(z.string().email()),
  to: line.pipe(z.string().email()),
  categories: z.array(z.enum(EMAIL_ALERT_CATEGORIES)).min(1).max(4),
}).strict();
export const updateNotificationEmailSchema = notificationEmailConfigSchema.extend({ password: z.string().max(4096).optional() });
export type NotificationEmailConfig = z.infer<typeof notificationEmailConfigSchema>;
export interface NotificationEmailDeliveryDto {
  notificationId: string;
  title: string;
  state: 'sending' | 'sent' | 'retryable' | 'unknown' | 'skipped';
  error: 'smtp_failed' | 'delivery_unknown' | null;
  updatedAt: string;
}
export interface NotificationEmailSettingsDto {
  config: NotificationEmailConfig | null;
  hasPassword: boolean;
  running: boolean;
  deliveries: NotificationEmailDeliveryDto[];
}
